/**
 * The special actions this person may not run on a document type (USR-007).
 *
 * The server refuses them anyway; this keeps them off the Action menu. While
 * the answer is loading, or if it fails, nothing is hidden — the server is the
 * gate, this is only so the menu does not offer what will be refused.
 */
import { useQuery } from '@tanstack/react-query'
import { useApi } from '../app/api.js'
import { adminApi } from '../app/admin-api.js'

export const useDeniedSpecialActions = (docType: string | undefined): ReadonlySet<string> => {
  const api = useApi()
  const q = useQuery({
    queryKey: ['mySpecialActions', api.companyId, docType],
    queryFn: () => adminApi(api).mySpecialActions(docType ?? ''),
    enabled: Boolean(docType) && typeof api.send === 'function',
    staleTime: 30_000,
  })
  return new Set(q.data?.denied ?? [])
}
